import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { AuthorizationService } from './authorization.service';
import { EnvironmentService } from '../../services/environment.service';

@Injectable()
export class LegendaryService {
    private APPBASE_URL: string;

    constructor(private http: Http, private auth: AuthorizationService, private environment: EnvironmentService) {
        this.APPBASE_URL = environment.APPBASE_URL;
    }

    public fetchControls(): Observable<any> {
        return this.http.get(`${this.APPBASE_URL}/Legendary/RandomizerControls`, { headers: this.auth.getAuthHeader() })
            .map(response => response.json());
    }

    public fetchMarvelSettings(): Observable<any> {
        return this.http.get(`${this.APPBASE_URL}/Legendary/MarvelSettings`, { headers: this.auth.getAuthHeader() })
            .map(response => response.json());
    }

    public legendaryRandomize(data: any): Observable<any> {
        //let headers = new Headers({ 'Content-Type': 'application/json' });
        let headers = this.auth.postAuthHeader();
        const value = data;

        return this.http.post(`${this.APPBASE_URL}/Legendary/RandomizeGame`, JSON.stringify(value), { headers: headers })
            .map(response => response.json());
    }

    public fetchEncountersControls(): Observable<any> {
        return this.http.get(`${this.APPBASE_URL}/Encounters/RandomizerControls`, { headers: this.auth.getAuthHeader() })
            .map(response => response.json());
    }

    public fetchEncountersSettings(): Observable<any> {
        return this.http.get(`${this.APPBASE_URL}/Encounters/LoadSettings`, { headers: this.auth.getAuthHeader() })
            .map(response => response.json());
    }

    public encountersRandomize(data: any): Observable<any> {
        //let headers = new Headers({ 'Content-Type': 'application/json' });
        let headers = this.auth.postAuthHeader();
        const value = data;

        return this.http.post(`${this.APPBASE_URL}/Encounters/RandomizeGame`, JSON.stringify(value), { headers: headers })
            .map(response => response.json());
    }

    public fetchUserSettings(): Observable<any> {
        return this.http.get(`${this.APPBASE_URL}/Legendary/UserSettings`, { headers: this.auth.getAuthHeader() })
            .map(response => response.json());
    }

    public userSettingsUpdate(data: any): Observable<any> {
        //let headers = new Headers({ 'Content-Type': 'application/json' });
        let headers = this.auth.postAuthHeader();
        const value = data;

        return this.http.post(`${this.APPBASE_URL}/Legendary/UserSettingsUpdate`, JSON.stringify(value), { headers: headers });
            //.map(response => response.json());
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./Apps/legendary/services/legendary.service.ts